import React, { useContext, Fragment } from "react";
import { Route, Redirect } from "react-router-dom";
import { BuildingContext } from "Context/BuildingProvider";
import { Snackbar } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";

export default function BuildingRoute({ component: RouteComponent, ...rest }) {
  const { currentBuilding } = useContext(BuildingContext);

  const [open, setOpen] = React.useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  return (
    <Route
      {...rest}
      render={(routeProps) =>
        currentBuilding.BuildingName !== "" ? (
          <RouteComponent {...routeProps} />
        ) : (
          <Fragment>
            <Snackbar
              open={open}
              autoHideDuration={6000}
              onClose={handleClose}
              message="Hi"
            >
              {/*// @ts-ignore */}
              <Alert variant="outlined" severity="error">
                {"Test"}
              </Alert>
            </Snackbar>
            <Redirect
              to={{
                pathname: "/app/dashboard",
                state: { prevPath: rest.path },
              }}
            />
          </Fragment>
        )
      }
    />
  );
}
